import styled from 'styled-components';

export const RatchetScheduleViewStyles = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
	gap: 1rem;
	margin-top: 0.25rem;

	.item {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;

		&-head {
			border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
			padding: 0.5rem;
			background: ${({ theme }) => theme.v3.colors.gray[0]};
		}

		&-body {
			padding: 0.5rem;
		}
	}
`;
